import React, { createContext, useContext, useState, ReactNode } from 'react';

export type ItineraryFeeTypeId = string | null;
type SelectItineraryFeeTypeId = (id: ItineraryFeeTypeId) => void;

interface ItineraryFeeTypeProviderProps {
  children: ReactNode;
}

const ItineraryFeeTypeIdContext = createContext<ItineraryFeeTypeId>(null);
const ItineraryFeeTypeIdSelectionContext =
  createContext<SelectItineraryFeeTypeId>(() => {});

export const ItineraryFeeTypeProvider: React.FC<
  ItineraryFeeTypeProviderProps
> = ({ children }) => {
  const [itineraryFeeTypeId, selectItineraryFeeTypeId] =
    useState<ItineraryFeeTypeId>(null);

  return (
    <ItineraryFeeTypeIdContext.Provider value={itineraryFeeTypeId}>
      <ItineraryFeeTypeIdSelectionContext.Provider
        value={selectItineraryFeeTypeId}
      >
        {children}
      </ItineraryFeeTypeIdSelectionContext.Provider>
    </ItineraryFeeTypeIdContext.Provider>
  );
};

export const useItineraryFeeTypeId = (): ItineraryFeeTypeId =>
  useContext(ItineraryFeeTypeIdContext);

export const useItineraryFeeTypeIdSelection = (): SelectItineraryFeeTypeId =>
  useContext(ItineraryFeeTypeIdSelectionContext);
